import React from 'react';
import { motion } from 'framer-motion';
const rows = [{
  icon: '⏰',
  without: '3-5 horas/semana planificando desde cero',
  with: '10 min/semana. El resto es enseñar.'
}, {
  icon: '😓',
  without: 'Siempre los mismos ejercicios → las alumnas se aburren',
  with: '60+ clases distintas → siempre hay algo nuevo'
}, {
  icon: '💸',
  without: 'Alumnas que abandonan sin saber por qué',
  with: 'Sistema de progresión → retención visible'
}, {
  icon: '📋',
  without: 'Sin progresión clara de nivel a nivel',
  with: '6 tomos con progresión anual → mejoran y se quedan'
}, {
  icon: '😨',
  without: 'Alumna con lesión = pánico o improvisación',
  with: 'Safe Pilates Pro → adaptación segura y profesional'
}, {
  icon: '👥',
  without: 'Niveles mezclados = caos de clase',
  with: 'Variaciones en 3 niveles → todas mejoran juntas'
}, {
  icon: '📱',
  without: 'Sin sistema de comunicación con alumnas',
  with: '18 flyers listos + 30 días de contenido planificado'
}, {
  icon: '💼',
  without: 'Sin identidad profesional visible',
  with: 'Sistema que justifica cobrar lo que merecés'
}];
export const ComparisonTable = () => {
  return <section className="py-8 md:py-14 bg-white" data-id="element-41">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="text-center mb-8 md:mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-6xl font-bold text-charcoal font-playfair mb-3 md:mb-6" data-id="element-44">
            PILATES 360™
          </h2>
          <p className="text-base md:text-xl text-gray-600 mb-1 md:mb-2" data-id="element-45">
            El próximo lunes podés volver a improvisar la clase.
          </p>
          <p className="text-base md:text-xl text-sage font-bold mb-4 md:mb-8" data-id="element-46">
            O podés entrar al estudio con todo resuelto desde hoy.
          </p>
          <h3 className="text-lg md:text-2xl font-bold text-charcoal" data-id="element-47">
            ¿Cuánto cuesta NO tenerlo?
          </h3>
        </div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-48">
          <div className="grid grid-cols-[auto_1fr_1fr] bg-gray-50 border-b border-gray-200" data-id="element-49">
            <div className="p-2 md:p-6" data-id="element-50"></div>
            <div className="p-2 md:p-6 font-bold text-red-800 text-center uppercase tracking-wider text-[10px] md:text-base" data-id="element-51">
              SIN PILATES 360
            </div>
            <div className="p-2 md:p-6 font-bold text-sage-800 text-center uppercase tracking-wider text-[10px] md:text-base bg-sage-50" data-id="element-52">
              CON PILATES 360
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-53">
            {rows.map((row, index) => <motion.div key={index} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="grid grid-cols-[auto_1fr_1fr] items-center hover:bg-gray-50 transition-colors" data-id="element-54">
                <div className="p-2 md:p-6 text-lg md:text-2xl text-center" data-id="element-55">
                  {row.icon}
                </div>
                <div className="p-2 md:p-6 text-gray-600 text-xs md:text-base" data-id="element-56">
                  {row.without}
                </div>
                <div className="p-2 md:p-6 font-medium text-sage-900 bg-sage-50/30 text-xs md:text-base" data-id="element-57">
                  {row.with}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};